import React from 'react';
import { Toaster as Sonner } from 'sonner';
import {
  BanknoteX,
  CircleCheck,
  Frown,
  Info,
  Loader,
  TabletSmartphone,
  ThumbsUp,
  TriangleAlert,
} from 'lucide-react';
import { Icon } from '@ideoz/ui';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  // Icon mapping from the original Snackbar component
  const icons = {
    success: CircleCheck,
    errorAI: BanknoteX,
    wait: Loader,
    responsive: TabletSmartphone,
    thankYou: ThumbsUp,
    sorry: Frown,
    error: Frown,
    warning: TriangleAlert,
    info: Info,
  };

  return (
    <Sonner
      theme="light"
      position="top-right"
      duration={5000}
      swipeDirections={['right']}
      closeButton={false}
      richColors={false}
      visibleToasts={5}
      icons={{
        success: <Icon icon={icons.success} color="#12b76a" size={18} strokeWidth={2} />,
        error: <Icon icon={icons.error} color="#f04438" size={18} strokeWidth={2} />,
        warning: <Icon icon={icons.warning} color="#f79009" size={18} strokeWidth={2} />,
        info: <Icon icon={icons.info} color="#4e5ba6" size={18} strokeWidth={2} />,
      }}
      className="toaster group"
      style={{
        position: 'fixed',
        top: '52px',
        right: '8px',
      }}
      toastOptions={{
        style: {
          backgroundColor: '#181D27', // primary-900
          color: 'white',
          border: '1px solid #414651', // primary-800
          boxShadow: '0 1.5px 5px 0 rgba(2, 28, 18, 0.15)',
          borderRadius: '8px',
        },
        classNames: {
          toast:
            'group toast bg-gray-900 text-white border-primary-800 shadow-lg rounded-lg px-4 py-3 group-[.toaster]:pointer-events-auto',
          description: 'text-white',
          success: 'bg-gray-900 text-white border-primary-800',
          error: 'bg-gray-900 text-white border-primary-800',
          warning: 'bg-gray-900 text-white border-primary-800',
          info: 'bg-gray-900 text-white border-primary-800',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
